import { useContext } from 'react'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/modalProvider'

import { useNavigate } from '../../../hooks/useNavigate'

import { CenterItem } from '../../../components/common'
import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

import { ReactComponent as ExclamationIcon } from '../../../assets/gui/exclamation_60.svg'

function AlreadyWithdrawalNotifyModal() {
  const { closeModal } = useContext(ModalContext)

  const navigate = useNavigate()

  const dismiss = () => {
    navigate('/signIn', { replace: true })
    closeModal(MODALS_ID.ALREADY_WITHDRAWAL_NOTIFY)
  }

  return (
    <Modal id={MODALS_ID.ALREADY_WITHDRAWAL_NOTIFY} onClose={dismiss}>
      <CenterItem $direction="column" $gap={16}>
        <ExclamationIcon />
        <Text size={16} weight={500} lineHeight={24} block={true} $textAlign="center">
          탈퇴 시점으로 부터 30일 후에
          <br />
          재가입이 가능해요.
        </Text>
      </CenterItem>
      <Modal.Footer>
        <Button block={true} onClick={dismiss}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AlreadyWithdrawalNotifyModal
